import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UiFilterOption } from '../../models/ui-table.model';

@Component({
  selector: 'app-ui-filter-select',
  templateUrl: './ui-filter-select.component.html',
  styleUrls: ['./ui-filter-select.component.scss']
})
export class UiFilterSelectComponent {
  @Input() label = '';
  @Input() options: UiFilterOption[] = [];
  @Input() value = '';
  @Input() showIcon = true;
  @Output() valueChange = new EventEmitter<string>();

  onChange(event: Event): void {
    const val = (event.target as HTMLSelectElement).value;
    this.value = val;
    this.valueChange.emit(val);
  }
}
